import * as React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'

import {Button, TYPES} from './../shared/button'
import Modal from './../shared/modal'
import {createPdfReport, convertImage} from './../shared/utils'
import Note from './note'
import download from './../../images/download.png'
import './../../styles/recordings/viewNotes.css'

var strftime = require('strftime')

class ViewNotes extends React.Component {
  constructor() {
    super()

    this.state = {
      note: null,
      data: false,
      modal: false,
      component: null,
      image: null,
      fullImage: null,
      index: null,
      zoom: false
    }
  }

  showModal = (id) => {
    const { token } = this.props.auth
    this.setState({modal: true})
    axios.get(
      `/api/notes/${id}.json`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${token}`
        }
      }
    ).then( response => {
      this.setState({note: response.data})
      this.setState({data: true})
    })
  }

  hideModal = () => {
    this.setState({modal: false})
  }


  runConvertImage = () => {
    const mainImage = this.refs.noteImage
    const secondaryImage = this.refs.fullImage
    let mainUrlImage, secondaryUrlImage
    const note = this.props.notes[this.state.index]
    mainImage.onload = () =>  {
      mainUrlImage = convertImage(document, mainImage)
      if(secondaryImage.src !== "") {
        secondaryImage.onload = () => {
          secondaryUrlImage = convertImage(document, secondaryImage)
          createPdfReport(note, mainUrlImage, secondaryUrlImage, this.props.license_plate)
        }
      } else {
        createPdfReport(note, mainUrlImage, null, this.props.license_plate)
      }
    }
  }

  render () {
    const { modal } = this.state
    const { notes } = this.props
    return (
      <div className='reportContainer'>
        <div className='note-header'>
          <p>View Notes</p>
        </div>
        <table className='notes-table'>
        <thead>
            <tr>
              <th className='notes-header-one'>Title</th>
              <th className='notes-header-two'>Reviewer</th>
              <th className='notes-header-one'>Date</th>
              <th className='notes-header-two'>Action</th>
            </tr>
          </thead>
          <tbody>
          {notes.map((item, index)=> {
              return (
                  <tr className='notes-row' key={"something" + index}>
                    <td>{notes[index].title}</td>
                    <td>{notes[index].reviewer}</td>
                    <td>{strftime('%B %d, %Y %I:%M %p', new Date(notes[index].created_at))}</td>
                    <td className='button'>
                      <Button
                        text='View Note'
                        type='note'
                        onClick={() => {this.showModal(notes[index].id)}}
                        buttonType={TYPES.DEFAULT}
                      />
                      <button
                        className='download-button'
                        onClick={
                          () => this.setState({image: notes[index].image, fullImage: notes[index].zoom_image, index: index},
                          () => this.runConvertImage())
                        }
                      >
                        <img src={download} alt='download note'/>
                      </button>
                    </td>
                  </tr>
              )
            }
            )
          }
          </tbody>
        </table>

        {modal &&
          <Modal onCloseRequest={() => this.hideModal()}>
          {this.state && this.state.data &&
            <Note note={this.state.note} license_plate={this.props.license_plate}/>
          }
          </Modal>}
          <div className='hidden-image'>
            <img src={this.state.image} ref='noteImage' alt='hidden' crossOrigin='anonymous' />
            <img src={this.state.fullImage} ref='fullImage' alt='hidden zoom' crossOrigin='anonymous' id='full-image'/>
          </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect( mapStateToProps )( ViewNotes )



// WEBPACK FOOTER //
// ./src/components/note/viewNotes.js